<script>
    import { onDestroy, onMount } from "svelte";
    import { fade } from "svelte/transition";
    import Spinning from "../icons/Spinning.svelte";
    import { AddURLResult, checkIframeURL, checkWindowURL } from "../init";
    import { iframeConfig } from "../store";


    let ready = false;
    let showIframe =false
    let height = 0;
    onMount(async ()=>{
        
        if($iframeConfig){
            //load iframe
            ready = true;
        
        }else{
            //back?
            window.history.back();
        }
    
    })

    onDestroy(()=>{
        console.log('iframe done')
        iframeConfig.set(null);
    });

    function urlLoadedInFrame(){
        console.log('loaded');
        const viewobj = document.getElementById('-1');
        console.log(viewobj)
        height = viewobj.clientHeight;
        setTimeout(()=>{showIframe = true},100);

        if(!checkIframeURL($iframeConfig.url)){
            AddURLResult($iframeConfig.url);
        }
    }
    
    function urlErrorInFrame(){

        //save result
        if(!checkWindowURL($iframeConfig.url)){
            AddURLResultWindow($iframeConfig.url);
        }
     
        ExternalRefOpen($iframeConfig.url)
        
    }
</script>

<div>

{#if ready && $iframeConfig && $iframeConfig.url && $iframeConfig.url !==undefined}
    <iframe src="{$iframeConfig.url}" frameborder="0" title="{$iframeConfig.title}"  on:load="{urlLoadedInFrame}" on:error="{urlErrorInFrame}" style="height:{height}px" />
{/if}
{#if !showIframe}
    <div id="iframe-loader" out:fade>
        <Spinning color={userColor} />
    </div>
{/if}

</div>

<style>
    #iframe-loader{
        position: absolute;
        top: 0;
        width: 100%;
        min-width: 100%;
        height: 100%;
        min-height: 100%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        margin: 0;
        padding: 0;
    }

    iframe{
        width: 100%;
        min-width: 100%;
        height: 100%;
        min-height: 100%;
        overflow:auto!important;
        -webkit-overflow-scrolling: touch;
        border: none;
        
    }
    :global(#iframe-loader svg){
        width: 100px;
        height: 100px;
        animation: spin 2s linear infinite;
        -webkit-animation: spin 2s linear infinite;
    }

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotateZ(0);
        }
        100% {
            -webkit-transform: rotateZ(360deg);
        }
    }
    @keyframes spin {
        0% {
            transform: rotateZ(0);
        }
        100% {
            transform: rotateZ(360deg);
        }
    }

</style>